<script>

export default {
  name: "Language",
  computed: {
    languageIcon() {
      let language = localStorage.getItem('lang') || process.env.VUE_APP_LANG;
      if (language === 'en-US' || language === '"en-US"') {
        language = 'en'
      } else if (language === 'zh-CN' || language === "'zh-CN'") {
        language = 'cn'
      } else if (language === 'zh-TW' || language === "'zh-TW'") {
        language = 'tw'
      }
      const icon = {
        "cn": require("@/assets/image/language/cn.png"),
        "en": require("@/assets/image/language/en.png"),
        "tw": require("@/assets/image/language/tw.png"),
        "de": require("@/assets/image/language/de.png"),
        "ja": require("@/assets/image/language/ja.png"),
        "ms": require("@/assets/image/language/ms.png"),
        "th": require("@/assets/image/language/th.png"),
        "pt": require("@/assets/image/language/pt.png"),
        "es": require("@/assets/image/language/es.png"),
        "ru": require("@/assets/image/language/ru.png"),
        "el": require("@/assets/image/language/el.png"),
        "it": require("@/assets/image/language/it.png"),
        "tr": require("@/assets/image/language/tr.png"),
        "fr": require("@/assets/image/language/fr.png"),
        "ko": require("@/assets/image/language/ko.png"),
        "ph": require("@/assets/image/language/ph.png"),
        "ar": require("@/assets/image/language/ar.png"),
        "vi": require("@/assets/image/language/vi.png"),
        "hi": require("@/assets/image/language/hi.png"),
        "id": require("@/assets/image/language/id.png"),
      };
      return language ? icon[language] : icon['en'];
    },
  },
}
</script>

<template>
  <div @click="$router.push('/Language')" class="lang-wrap">
    <img :src="languageIcon" alt="" class="lang-img"/>
  </div>
</template>

<style scoped lang="less">
.lang-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:active {
    opacity: 0.7;
  }

  .lang-img {
    height: 44px;
    width: 44px;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    object-fit: cover;
    display: block;
  }
}

// PC端适配：保持与手机端相同的样式，按比例缩放 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  .lang-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px; /* 10px * 0.5733 ≈ 6px */
    cursor: pointer;
    transition: opacity 0.2s;

    &:active {
      opacity: 0.7;
    }

    .lang-img {
      height: 25px; /* 44px * 0.5733 ≈ 25px */
      width: 25px; /* 44px * 0.5733 ≈ 25px */
      box-shadow: 0 0 1px rgba(0, 0, 0, 0.1); /* 保持相同的阴影效果 */
      border-radius: 50%; /* 保持圆形 */
      object-fit: cover;
      display: block;
    }
  }
}
</style>